<template>
  <v-flex xs12>

    <div v-if="pCodTracking && pCodTracking.tipoTracking === 'E'">
      <p class="datSectionSubTitle">{{ $t('codTracking') }}: {{ pCodTracking.codTracking }}</p>
    </div>

    <v-card-actions v-if="pUrlTracking != ''">
      <v-btn flat block class="datPrimaryBtnOut" small @click="fVerAgencia">
        {{ $t('agenciaTransporteLink') }}
      </v-btn>
    </v-card-actions>
    <v-select v-if="pBultos[0]" :label="this.$t('selecBultoAlb')" :items="pBultos" v-model="bultoSeleccionado">
    </v-select>
    <v-timeline class="datTrackingCard" :dense="$vuetify.breakpoint.xs" v-if="pItems && pItems.length > 0">
      <v-timeline-item v-for="(item, index) in elementoFiltrado" :key="index"
        :color="index != 0 ? 'datSecondary opacity' : 'datLink'" small>
        <v-card flat class="">
          <v-card-title class="py-1" :class="index != 0 ? 'trackingLabel' : 'trackingLabelActive'">
            <span class="font-weight-bold" :class="index != 0 ? 'trackingLabel' : 'trackingLabelActive'">{{ item.estado
            }}</span>
          </v-card-title>
          <v-card-text class="py-1">
            <v-flex>
              <v-layout row wrap align-center>
                <v-flex class="pa-1 iconBlock">
                  <v-icon :color="index != 0 ? '' : 'datLink'" size="18">mdi-calendar-blank</v-icon>
                </v-flex>
                <v-flex shrink class="pa-1 trackingLabel"> {{ item.fecha }}
                </v-flex>
                <v-flex class="pa-0 " xs12>
                </v-flex>
                <v-flex shrink class="pa-1 iconBlock">
                  <v-icon :color="index != 0 ? '' : 'datLink'" size="18">mdi-clock-outline</v-icon>
                </v-flex>
                <v-flex xs10 class="pa-1 trackingLabel"> {{ item.hora }}
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>

        </v-card>
      </v-timeline-item>
    </v-timeline>
  </v-flex>
</template>

<script>
export default {
  name: 'ShpTimeline',
  components: {
  },
  props: {
    pBultos: {
      type: Array,
      required: true
    },
    pItems: {
      type: Array,
      required: true
    },
    pUrlTracking: {
      type: String,
      required: false,
      default: ''
    },
    pCodTracking: {
      type: Object,
      required: false,
      default: {}
    },
    pColor: {
      type: String,
      default: 'red',
      required: true
    }
  },
  data() {
    return {
      bultoSeleccionado: null
    }
  },
  computed: {
    elementoFiltrado() {
      // Si this.pBultos[0] tiene valor significa que va por bultos, por lo que solo mostramos el seleccionado.
      if (this.pBultos[0]) {
        return this.pItems.filter(item => item.numBulto === this.bultoSeleccionado);
      }
      else {
        // En el caso contrario no va por bultos, por lo que se muestra el albarán
        return this.pItems;
      }
    }
  },
  watch: {
    pBultos: {
      handler(valor) {
        // Llama a la función cada vez que pBultos cambie
        if (valor[0]) {
          this.bultoSeleccionado = valor[0];
        }
        else {
          this.bultoSeleccionado = null;
        }
      },
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  mounted() {
  },
  methods: {
    cerrarVentana() {
      this.estadoAlbaran = false
    },
    fVerAgencia() {
      window.open(this.pUrlTracking, '_blank');
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Pelikane/ShpTimeline.vue